(() => {
  if (window.nomkunInitialized) return;
  window.nomkunInitialized = true;
  let lastTrigger;
  const closeMenu = () => {
    document.querySelectorAll('[data-nk-header]').forEach(header => {
      header.removeAttribute('data-menu-open');
      header.querySelector('.nk-menu-toggle')?.setAttribute('aria-expanded', 'false');
    });
  };
  const selectSlide = (hero, index) => {
    const slides = [...hero.querySelectorAll('[data-nk-slide]')];
    if (!slides.length) return;
    const next = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      slide.hidden = i !== next;
      slide.classList.toggle('is-active', i === next);
    });
    hero.querySelectorAll('[data-nk-slide-to]').forEach((button, i) => {
      if (i === next) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
  };
  const selectEditPage = (edit, index) => {
    const pages = [...edit.querySelectorAll('[data-nk-edit-page]')];
    const next = Math.max(0, Math.min(pages.length - 1, index));
    pages.forEach((page, position) => { page.hidden = position !== next; });
    edit.querySelector('[data-nk-edit-step="-1"]').disabled = next === 0;
    edit.querySelector('[data-nk-edit-step="1"]').disabled = next === pages.length - 1;
    const status = edit.querySelector('[data-nk-edit-status]');
    status.textContent = status.dataset.template.replace('[current]', String(next + 1)).replace('[total]', String(pages.length));
  };
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const cartOpener = target.closest('.nk-cart[cart-icon-bubble]');
    if (cartOpener) {
      const notification = document.querySelector('cart-notification');
      if (notification) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (typeof notification.open !== 'function') window.triggerScripts?.();
        Promise.race([
          customElements.whenDefined('cart-notification').then(() => true),
          new Promise(resolve => setTimeout(() => resolve(false), 6000))
        ]).then(ready => {
          if (ready) {
            notification.setActiveElement(cartOpener);
            notification.open();
          } else window.location.assign(cartOpener.href);
        });
        return;
      }
    }
    const toggle = target.closest('.nk-menu-toggle');
    if (toggle) {
      const header = toggle.closest('[data-nk-header]');
      const open = !header.hasAttribute('data-menu-open');
      header.toggleAttribute('data-menu-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    }
    if (target.closest('.nk-nav a')) closeMenu();
    const mobileAnchor = target.closest('[data-nk-mobile-anchor]');
    if (mobileAnchor && document.body.classList.contains('index-page') && matchMedia('(max-width:749px)').matches) {
      const destination = document.getElementById(mobileAnchor.dataset.nkMobileAnchor);
      if (destination) { event.preventDefault(); destination.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'}); }
    }
    const editButton = target.closest('[data-nk-edit-step]');
    if (editButton) {
      const edit = editButton.closest('[data-nk-mobile-edit]');
      const pages = [...edit.querySelectorAll('[data-nk-edit-page]')];
      const current = pages.findIndex(page => !page.hidden);
      selectEditPage(edit, current + Number(editButton.dataset.nkEditStep));
    }
    const opener = target.closest('[data-nk-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.nkOpen);
      if (dialog instanceof HTMLDialogElement) {
        lastTrigger = opener;
        dialog.showModal();
        if (dialog.classList.contains('nk-search-dialog')) dialog.querySelector('input[type="search"]')?.focus();
      }
    }
    const closer = target.closest('[data-nk-close]');
    if (closer) closer.closest('dialog')?.close();
    if (target instanceof HTMLDialogElement && target.classList.contains('nk-dialog')) {
      const rect = target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) target.close();
    }
    const slideButton = target.closest('[data-nk-slide-to]');
    if (slideButton) selectSlide(slideButton.closest('[data-nk-hero]'), Number(slideButton.dataset.nkSlideTo));
  });
  document.addEventListener('close', event => {
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('nk-dialog')) lastTrigger?.focus();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeMenu();
      const notification = document.querySelector('cart-notification');
      if (notification?.querySelector('.cart-notification.active')) notification.close();
    }
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-nk-slide-to]');
    if (button && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
      event.preventDefault();
      const hero = button.closest('[data-nk-hero]');
      const index = Number(button.dataset.nkSlideTo) + (event.key === 'ArrowRight' ? 1 : -1);
      selectSlide(hero, index);
      hero.querySelector('[aria-current="true"]')?.focus();
    }
  });
  document.addEventListener('change', event => {
    if (event.target instanceof Element && event.target.matches('[data-nk-locale]')) event.target.closest('form')?.requestSubmit();
  });
  document.addEventListener('shopify:block:select', event => {
    const page = event.target.closest('[data-nk-edit-page]');
    if (page) {
      const edit = page.closest('[data-nk-mobile-edit]');
      selectEditPage(edit, [...edit.querySelectorAll('[data-nk-edit-page]')].indexOf(page));
    }
    const slide = event.target.closest('[data-nk-slide]');
    if (!slide) return;
    const hero = slide.closest('[data-nk-hero]');
    selectSlide(hero, [...hero.querySelectorAll('[data-nk-slide]')].indexOf(slide));
  });
  const updateCart = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers: {Accept: 'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-nk-cart-count]').forEach(count => { count.textContent = String(cart.item_count); count.classList.toggle('is-empty', cart.item_count === 0); count.classList.toggle('d-none', cart.item_count === 0); });
    } catch {}
  };
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(name => document.addEventListener(name, updateCart));
  window.addEventListener('pageshow', event => { if (event.persisted) updateCart(); });
})();
